/**
 * Repack a 12-column dashboard layout for narrow viewports, in memory only.
 * Items are taken in reading order (row, then column) and re-flowed into `columns`
 * equal-width slots (1 on phones, 2 on tablets); heights are kept, except that short
 * statistic tiles get a readable minimum. Never persist the result: it is a view of
 * the stored layout, not a change to it.
 */
export const GRID_COLS = 12;

export function viewportColumns(width) {
  if (width < 768) return 1;
  if (width < 1200) return 2;
  return 0; // 0 = use the stored layout as is
}

export function repackLayout(layout, columns) {
  if (!columns || columns >= GRID_COLS) return layout;
  const slot = GRID_COLS / columns;
  const items = [...layout].sort((a, b) => (Number(a.y) - Number(b.y)) || (Number(a.x) - Number(b.x)));
  let x = 0, y = 0, rowH = 0;
  return items.map(item => {
    const isSection = Number(item.widget_type_id) === 4;
    const w = isSection ? GRID_COLS : (Number(item.w) > slot ? GRID_COLS : slot);
    let h = Number(item.h) || 1;
    if (Number(item.widget_type_id) === 3 && h < 12) h = 12;
    if (x + w > GRID_COLS) { x = 0; y += rowH; rowH = 0; }
    const placed = { ...item, x, y, w, h };
    x += w; rowH = Math.max(rowH, h);
    return placed;
  });
}
